/**
 * 采用父子路由结构，子任务列表页与任务管理列表页共享同一个 navTab，
 * 不会新开标签页，navtabTitle 使用函数动态返回组名。
 */
const routes = [
  {
    path: 'task',
    name: 'task',
    component: { template: '<router-view></router-view>' },
    children: [
      {
        path: '',
        name: 'taskList',
        component: () => import('./index.vue'),
        meta: {
          navtabTitle: '任务管理',
          permission: 'iff:gnmk:task:view',
          isCache: true
        }
      },
      {
        // 子任务列表页，通过 query 传递 groupId/groupName/cycleType/taskType
        path: 'tasks',
        name: 'taskTasks',
        component: () => import('./taskList.vue'),
        meta: {
          // 动态标题：优先使用路由 query 带过来的任务组名
          navtabTitle: (route) => route.query.groupName || '子任务列表',
          permission: 'iff:gnmk:task:view',
          isCache: true
        }
      }
    ]
  }
];

export default routes;
